import React, { useState } from "react";
import { X, ZoomIn, ChevronLeft, ChevronRight } from "lucide-react";
import { GALLERY_PHOTOS } from "../data/assets";
import { useI18n } from "../data/i18n";
import Reveal from "../components/Reveal";

const DiamondDivider = () => (
  <div className="flex items-center justify-center gap-2 my-4">
    <div className="w-12 h-px bg-gradient-to-r from-transparent to-[#e4c590]"></div>
    <span className="diamond-mark"></span>
    <span className="diamond-mark opacity-60"></span>
    <span className="diamond-mark"></span>
    <div className="w-12 h-px bg-gradient-to-l from-transparent to-[#e4c590]"></div>
  </div>
);

// Автоматично определяне на височина според индекса
const getHeightClass = (index) => {
  const patterns = ["tall", "short", "med", "short", "tall", "med", "med", "tall", "short", "tall", "med", "short"];
  return patterns[index % patterns.length];
};

const Gallery = () => {
  const { t } = useI18n();
  const [selectedIdx, setSelectedIdx] = useState(null);

  // Ако няма снимки, показваме съобщение
  if (GALLERY_PHOTOS.length === 0) {
    return (
      <div className="bg-[#0a0a0a] pt-32 pb-24 min-h-screen flex items-center justify-center">
        <div className="text-center text-[#cfc7b8]">
          <p>Все още няма снимки в галерията.</p>
          <p className="text-sm mt-2">Добавете снимки в папката src/assets/images/gallery/</p>
        </div>
      </div>
    );
  }

  const close = () => setSelectedIdx(null);
  const next = (e) => {
    e?.stopPropagation();
    setSelectedIdx((i) => (i === null ? 0 : (i + 1) % GALLERY_PHOTOS.length));
  };
  const prev = (e) => {
    e?.stopPropagation();
    setSelectedIdx((i) => (i === null ? 0 : (i - 1 + GALLERY_PHOTOS.length) % GALLERY_PHOTOS.length));
  };

  return (
    <div className="bg-[#0a0a0a] pt-32 pb-24 min-h-screen">
      <div className="max-w-7xl mx-auto px-6">
        <Reveal direction="up">
          <div className="text-center mb-16">
            <p className="section-label">{t("gallery.label")}</p>
            <h1 className="display text-5xl md:text-7xl text-[#f5f0e6] mt-3">{t("gallery.title")}</h1>
            <DiamondDivider />
            <p className="text-[#cfc7b8] italic max-w-2xl mx-auto">{t("gallery.subtitle")}</p>
          </div>
        </Reveal>

        {/* Автоматична галерия */}
        <div className="gallery-masonry">
          {GALLERY_PHOTOS.map((src, idx) => {
            const sizeClass = `gallery-tile-${getHeightClass(idx)}`;
            return (
              <Reveal key={idx} direction="zoom" delay={(idx % 8) * 60} className={`gallery-tile ${sizeClass}`}>
                <button onClick={() => setSelectedIdx(idx)} className="gallery-tile-btn group">
                  <img src={src} alt={`Gallery ${idx + 1}`} className="gallery-tile-img" loading="lazy" decoding="async" />
                  <div className="gallery-tile-overlay">
                    <div className="gallery-tile-zoom">
                      <ZoomIn size={20} />
                    </div>
                    <div className="gallery-tile-meta">
                      <span className="diamond-mark"></span>
                      <span>CASA BALA</span>
                      <span className="diamond-mark"></span>
                    </div>
                  </div>
                </button>
              </Reveal>
            );
          })}
        </div>

      </div>

      {/* Lightbox */}
      {selectedIdx !== null && (
        <div
          onClick={close}
          className="fixed inset-0 z-[100] flex items-center justify-center p-6 cursor-pointer modal-overlay-animate"
        >
          <button onClick={close} className="absolute top-6 right-6 text-white hover:text-[#e4c590] transition-colors z-10" aria-label="Close">
            <X size={32} />
          </button>
          <button onClick={prev} className="absolute left-4 md:left-8 top-1/2 -translate-y-1/2 w-12 h-12 border border-[#e4c590]/40 text-[#e4c590] rounded-full flex items-center justify-center hover:bg-[#e4c590] hover:text-[#0a0a0a] transition-colors z-10" aria-label="Previous">
            <ChevronLeft size={22} />
          </button>
          <img
            src={GALLERY_PHOTOS[selectedIdx]}
            alt="Gallery preview"
            className="max-w-full max-h-full object-contain modal-content-animate"
            decoding="async"
            onClick={(e) => e.stopPropagation()}
          />
          <button onClick={next} className="absolute right-4 md:right-8 top-1/2 -translate-y-1/2 w-12 h-12 border border-[#e4c590]/40 text-[#e4c590] rounded-full flex items-center justify-center hover:bg-[#e4c590] hover:text-[#0a0a0a] transition-colors z-10" aria-label="Next">
            <ChevronRight size={22} />
          </button>
          <div className="absolute bottom-6 left-1/2 -translate-x-1/2 text-[#cfc7b8] text-sm">
            {selectedIdx + 1} / {GALLERY_PHOTOS.length}
          </div>
        </div>
      )}
    </div>
  );
};

export default Gallery;